import { AllowedCallTypes, MakeActionCreator } from "../../common/const";
import { makeApiStateReducer } from "../../common/reducers/apiState";

const makeCreateStateReducer = ({
  name,
  path = "seneca/",
  idFieldName
}: MakeActionCreator) => {
  return makeApiStateReducer({
    name,
    path,
    idFieldName,
    callType: AllowedCallTypes.CREATE
  });
};

export default makeCreateStateReducer;
